import { FC } from 'react';
import { IconProps, oyster } from './types';

const ExpirationDateIcon: FC<IconProps> = ({ defaultColor, ...props }) => {
  const css = `
    .B{fill:#000}.C{fill-opacity:.12}.D{color-interpolation-filters:sRGB}.E{flood-opacity:0}
  `;
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <style>{css}</style>
      <g filter="url(#B)">
        <mask id="A" maskUnits="userSpaceOnUse" x="0" y="0">
          <path
            fillRule="evenodd"
            d="M16.342.854c7.691-.944 13.292 3.432 14.237 11.123l.536 4.367c.944 7.691-3.432 13.292-11.123 14.237l-4.367.536c-7.691.944-13.292-3.432-14.237-11.123l-.536-4.367C-.093 7.936 4.283 2.334 11.974 1.39l4.368-.536z"
            fill="url(#G)"
          />
        </mask>
        <g mask="url(#A)">
          <path
            d="M16.3952 1.29014C20.1445 0.829772 23.3458 1.66909 25.7192 3.52336C28.0925 5.37764 29.6814 8.28078 30.1418 12.0301L30.678 16.3976C31.1384 20.147 30.2991 23.3482 28.4448 25.7216C26.5905 28.095 23.6874 29.6838 19.938 30.1442L15.5705 30.6804C11.8212 31.1408 8.61989 30.3015 6.24653 28.4472C3.87316 26.5929 2.28431 23.6898 1.82395 19.9404L1.28769 15.573C0.827331 11.8236 1.66665 8.62233 3.52092 6.24897C5.3752 3.8756 8.27834 2.28675 12.0277 1.82639L16.3952 1.29014Z"
            fill={defaultColor ? props.fill : 'currentColor'}
            stroke="url(#H)"
            strokeWidth=".879"
          />
          <path
            d="M5.629 4.319c-2.405 1.625-3.885 4.654-4.061 6.333l26.939-2.639c-1.464-3.424-4.395-5.147-6.398-5.829s-4.175-.659-7.605-.328c-3.572.345-5.692.313-8.873 2.463z"
            className="B C"
          />
          <circle
            cx="5.279"
            cy="14.152"
            transform="rotate(353 5.279 14.152)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="8.755"
            cy="13.727"
            transform="rotate(353 8.755 13.727)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="12.231"
            cy="13.305"
            transform="rotate(353 12.231 13.305)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="15.706"
            cy="12.879"
            transform="rotate(353 15.706 12.879)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="19.182"
            cy="12.445"
            transform="rotate(353 19.182 12.445)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="5.766"
            cy="18.121"
            transform="rotate(353 5.766 18.121)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="9.242"
            cy="17.695"
            transform="rotate(353 9.242 17.695)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="12.718"
            cy="17.274"
            r="1.001"
            transform="rotate(353 12.718 17.274)"
            className="B C"
          />
          <circle
            cx="16.194"
            cy="16.848"
            transform="rotate(353 16.194 16.848)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="19.67"
            cy="16.414"
            r="1.001"
            transform="rotate(353 19.67 16.414)"
            className="B C"
          />
          <circle
            cx="23.146"
            cy="15.992"
            transform="rotate(353 23.146 15.992)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="26.622"
            cy="15.567"
            transform="rotate(353 26.622 15.567)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="6.255"
            cy="22.09"
            transform="rotate(353 6.255 22.09)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="9.73"
            cy="21.664"
            transform="rotate(353 9.73 21.664)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="13.206"
            cy="21.242"
            transform="rotate(353 13.206 21.242)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="16.682"
            cy="20.817"
            transform="rotate(353 16.682 20.817)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="20.158"
            cy="20.383"
            transform="rotate(353 20.158 20.383)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="23.634"
            cy="19.961"
            transform="rotate(353 23.634 19.961)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="27.11"
            cy="19.535"
            transform="rotate(353 27.11 19.535)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="13.694"
            cy="25.215"
            transform="rotate(353 13.694 25.215)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="10.201"
            cy="25.645"
            transform="rotate(353 10.201 25.645)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="6.725"
            cy="26.07"
            transform="rotate(353 6.725 26.07)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="17.17"
            cy="24.789"
            transform="rotate(353 17.17 24.789)"
            r="1.001"
            className="B C"
          />
          <circle
            transform="matrix(.9925 -.121869 .12187 .9925 20.6456 24.3634)"
            r="1.001"
            className="B C"
          />
          <circle
            transform="matrix(.9925 -.121869 .12187 .9925 24.1214 23.9415)"
            r="1.001"
            className="B C"
          />
          <circle
            cx="27.598"
            cy="23.508"
            transform="rotate(353 27.598 23.508)"
            r="1.001"
            className="B C"
          />
        </g>
        <g filter="url(#C)">
          <ellipse cx="15.978" cy="15.999" rx="10.984" ry="11.159" fill="#fff" />
        </g>
        <g filter="url(#D)">
          <rect
            x="16.763"
            y="6.324"
            width=".818"
            height="10.516"
            rx=".409"
            transform="rotate(7.222 16.763 6.324)"
            fill="#222"
          />
        </g>
        <g filter="url(#E)">
          <rect
            width="1.402"
            height="6.948"
            rx=".701"
            transform="matrix(-.1257 .992066 -.992066 -.1257 22.6821 16.8984)"
            fill="#222"
          />
        </g>
        <g filter="url(#F)">
          <circle cx="15.609" cy="17.114" fill="#bfc5cc" r="1.168" />
        </g>
      </g>
      <defs>
        <filter
          id="B"
          x=".578"
          y=".58"
          width="30.811"
          height="30.955"
          filterUnits="userSpaceOnUse"
          className="D"
        >
          <feFlood result="A" className="E" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="0.146568" />
          <feGaussianBlur stdDeviation=".073" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="A" result="C" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation=".073" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0" />
          <feBlend in2="C" />
          <feBlend in="SourceGraphic" />
        </filter>
        <filter
          id="C"
          x="3.649"
          y="3.495"
          width="24.656"
          height="25.006"
          filterUnits="userSpaceOnUse"
          className="D"
        >
          <feFlood result="A" className="E" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation=".672" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend in2="A" />
          <feBlend in="SourceGraphic" />
        </filter>
        <filter
          id="D"
          x="14.394"
          y="5.276"
          width="4.228"
          height="12.632"
          filterUnits="userSpaceOnUse"
          className="D"
        >
          <feFlood result="A" className="E" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation=".548" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="A" />
          <feBlend in="SourceGraphic" />
        </filter>
        <filter
          id="E"
          x="14.6"
          y="15.014"
          width="9.095"
          height="4.289"
          filterUnits="userSpaceOnUse"
          className="D"
        >
          <feFlood result="A" className="E" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation=".548" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="A" />
          <feBlend in="SourceGraphic" />
        </filter>
        <filter
          id="F"
          x="13.071"
          y="14.576"
          width="5.076"
          height="5.075"
          filterUnits="userSpaceOnUse"
          className="D"
        >
          <feFlood result="A" className="E" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation=".685" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend in2="A" />
          <feBlend in="SourceGraphic" />
        </filter>
        <linearGradient
          id="G"
          x1="44.442"
          y1="12.315"
          x2="12.404"
          y2="-12.565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3374f6" />
          <stop offset="1" stopColor="#00d3ed" />
        </linearGradient>
        <linearGradient
          id="H"
          x1="15.983"
          y1=".727"
          x2="15.983"
          y2="31.244"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#f8f8f8" />
          <stop offset="1" stopColor="#d0d0d0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

ExpirationDateIcon.defaultProps = {
  fill: oyster,
};

export default ExpirationDateIcon;
